import { Difficulty } from "shared/games/Difficulty";
import { MixPuzzle } from "shared/games/mixpuzzles/types";
import { GameAnswerMixPuzzle } from "shared/games/types/GameAnswers";
import getDefaultMixPuzzleInstruments from "./getDefaultMixPuzzleInstruments";
import { State } from "./reducer";
import { Params } from "./useMixPuzzleState";

export default function initState(params: Params): State {
  const firstInstrument = Object.values(params.mixPuzzle.instruments)[0]
    .instrument;

  if (params.type === "game-screen") {
    const { difficulty, mixPuzzle, __loadAnswerAsMix } = params;

    return {
      difficulty,
      playbackState: "mix",
      mixPuzzle,
      mix: __loadAnswerAsMix
        ? mixPuzzle.instruments
        : getDefaultMixPuzzleInstruments(mixPuzzle),
      instrument: firstInstrument,
      multiMixMode: false,
      soloed: null,
      muted: new Set(),
      grade: undefined,
    };
  }

  const { difficulty, grade, mixPuzzle } = params;
  const firstFailedeInstrument = Object.values(grade.issues)[0].instrument;

  return {
    difficulty,
    playbackState: "mix",
    mixPuzzle,
    mix: getDefaultMixPuzzleInstruments(mixPuzzle),
    instrument: firstFailedeInstrument ?? firstInstrument,
    multiMixMode: true,
    soloed: null,
    muted: new Set(),
    grade,
  };
}
